import { Bell, Briefcase, FileSignature, Users } from "lucide-react";
import type React from "react";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { useCrmPermission } from "../../../hooks/useCrmPermission";

type NavCard = {
  title: string;
  description: string;
  to: string;
  icon: ReactNode;
};

/**
 * CRMインデックスページ
 * CRM配下の各機能へのナビゲーションを提供する
 * @return {React.ReactElement} CRMインデックスページ
 */
const CrmIndexPage: React.FC = () => {
  const { isAdmin } = useCrmPermission();

  const cards: NavCard[] = [
    {
      title: "タレント管理",
      description: "人材の登録・スキル・稼働状況を管理",
      to: "/crm/talents",
      icon: <Users className="w-6 h-6" />,
    },
    {
      title: "営業管理",
      description: "案件と人材の営業進捗を管理",
      to: "/crm/sales-board",
      icon: <Briefcase className="w-6 h-6" />,
    },
    {
      title: "契約管理",
      description: "契約状況・期間・単価を管理",
      to: "/crm/contracts",
      icon: <FileSignature className="w-6 h-6" />,
    },
    ...(isAdmin
      ? [
          {
            title: "通知設定",
            description: "Slack通知ルールの設定",
            to: "/crm/notification-settings",
            icon: <Bell className="w-6 h-6" />,
          },
        ]
      : []),
  ];

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-6">CRM</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {cards.map(card => (
          <Link
            key={card.to}
            to={card.to}
            className="card bg-base-100 shadow-md hover:shadow-lg transition-shadow"
          >
            <div className="card-body p-5">
              <div className="flex items-center gap-3 mb-2">
                <span className="text-violet-600">{card.icon}</span>
                <h2 className="card-title text-base">{card.title}</h2>
              </div>
              <p className="text-sm text-base-content/60">{card.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default CrmIndexPage;
